import { Route, Routes } from 'react-router-dom';
import './App.css';
import Footer from './Components/Footer';
import Header from './Components/Header';
import Body from './Sections/Body';
import Ayurvedic from './Sections/Ayurvedic';
import BabyCare from './Sections/BabyCare';
import EnglishMed from './Sections/EnglishMed';
import PetAccess from './Sections/PetAccess';
import PetVacc from './Sections/PetVacc';
import PremiumPet from './Sections/PremiumPet';
import VeterineryMed from './Sections/VeterineryMed';
import MedicalEquip from './Sections/MedicalEquip';
import Dicounts from './Sections/Dicounts';
import Health from './Sections/Health';
import Contact from './Components/Contact';
function App() {
  return (
    <div className="App">
      <Header/>
      <Routes>
        <Route path='/' element={<Body/>}/>
        <Route path='/contact' element={<Contact/>}/>
        <Route path='/health' element={<Health/>}/>
        <Route path='/discounts' element={<Dicounts/>}/>
        <Route path='/ayurvedic' element={<Ayurvedic/>}/>
        <Route path='/medicalequipments' element={<MedicalEquip/>}/>
        <Route path='/babycare' element={<BabyCare/>}/>
        <Route path='/englishmedicines' element={<EnglishMed/>}/>
        <Route path='petaccessories' element={<PetAccess/>}/>
        <Route path='/beauty' element={<PetVacc/>}/>
        <Route path='/premiumpet' element={<PremiumPet/>}/>
        <Route path='/veterinary' element={<VeterineryMed/>}/>
      </Routes>
      <Footer/>
    </div>
  );
}

export default App;
